/* eslint-disable no-underscore-dangle */
import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import user from './user';
import users from './users';
import castings from './castings';
import companies from './companies';
import categories from './categories';
import statistic from './statistic';

const appReducer = combineReducers({
  user,
  users,
  companies,
  castings,
  categories,
  statistic,
});

const RESET_REDUX = 'RESET_REDUX';

const rootReducer = (state, action) => {
  if (action.type === RESET_REDUX) {
    state = undefined;
  }

  return appReducer(state, action);
};

export const resetRedux = () => ({
  type: RESET_REDUX,
});

const configureStore = () => createStore(rootReducer, applyMiddleware(thunk));

export default configureStore;
